import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DynamicGuardService } from '@workflow/dynamic-guard/dynamic-guard.decorator';
import { WorkflowWidgetEventServiceService } from '@workflow/widget/workflow-widget-event.service';
import { Info } from '../constant/information.const';
import { CanComponentDeactivate } from '../model/can-component-deactivate.type';
import { StorageWrapperService } from '../service/storage-wrapper/storage-wrapper.service';
import { UserService } from '../service/user/user.service';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const perAppPages = ['ola-consumer-interstitial', 'eligibility', 'ola-consumer-loan-type'];

@DynamicGuardService('OLAPreventApplicatinBackGuard')
@Injectable({
  providedIn: 'root'
})
export class OLAPreventApplicatinBackGuard {
  constructor(
    private readonly userService: UserService,
    private readonly router: Router,
    private readonly storageWrapperService: StorageWrapperService,
    private readonly widgetEventService: WorkflowWidgetEventServiceService
  ) {}

  public canDeactivate(
    component: CanComponentDeactivate,
    route: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.isAllowedPath(nextState.url);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot, next: ActivatedRouteSnapshot): boolean {
    return this.isAllowedPath(state.url, route);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private isAllowedPath(url: string, route: ActivatedRouteSnapshot = undefined): boolean {
    const isAuthenticated = this.userService.isAuthenticated;
    if (isAuthenticated && this.isRestrictRouteForLoginUser(url)) {
      this.router.navigateByUrl(`/consumer/dashboard?return=dashboard`);
      return false;
      // eslint-disable-next-line eqeqeq
    }
    // else if (!isAuthenticated && this.isOlaFlow(url) && perAppPages.filter((t) => url.includes(t)).length == 0) {
    //   this.userService.logout();
    //   this.router.navigate(['/user/login']);
    //   return false;
    // }
    return true;
  }

  private isRestrictRouteForLoginUser(url: string): boolean {
    const allowedRoute = this.storageWrapperService.get(Info.allowedRoute);
    if (allowedRoute === 'Consumer_PostApp' && this.isOlaFlow(url)) {
      return true;
    }
    return false;
  }

  private isOlaFlow(url: string): boolean {
    return url.includes('ola/') || url.includes('ola-consumer/');
  }
}
